import qs from 'query-string'
import { kronosRest } from '../../client'

export class Kronos {
  constructor(token) {
    this.token = token
  }

  // LT-3868: possibly not used
  async verifyEmail(token) {
    return await kronosRest(`/kronos/users/verify-email/?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
  }

  async getInsuranceProviders(productId) {
    return await kronosRest(`/kronos/insurance-provider/product/?productId=${productId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      }
    })
  }

  async setLeadsData(payload) {
    return await kronosRest(`/kronos/leads/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data: payload
    })
  }
}
